import { render, staticRenderFns } from "./SearchSides.vue?vue&type=template&id=25650fc4&scoped=true"
import script from "./SearchSides.vue?vue&type=script&lang=js"
export * from "./SearchSides.vue?vue&type=script&lang=js"
import style0 from "./SearchSides.vue?vue&type=style&index=0&id=25650fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25650fc4",
  null
  
)

export default component.exports